import { SEARCH } from "./Constants";

// entity key of Care at Home / LvL Health orders in the cloud search index
export const HOME_HEALTH_ENTITY = "Home Health";

/**
 * Single place that decides what a global search sends.
 * - LvL Health ticked + other entities ticked  -> no partner_scope (everything, LvL included)
 * - LvL Health ticked + no entity ticked       -> LvL Health only (Home Health entity + LVL_HEALTH)
 * - LvL Health unticked                        -> EXCLUDE_LVL_HEALTH (needs at least one entity)
 * Returns null when there is nothing valid to search for.
 */
export const buildGlobalSearchPath = ({ text, selectedEntities = [], includeLvlHealth = true }) => {
  const entities = (selectedEntities || []).map(ent => ent.value);
  let scope = "";
  let entityParam = entities;

  if (!includeLvlHealth) {
    if (!entities.length) return null;
    scope = "EXCLUDE_LVL_HEALTH";
  } else if (!entities.length) {
    scope = "LVL_HEALTH";
    entityParam = [HOME_HEALTH_ENTITY];
  }

  let path = `${SEARCH}?search_input=${encodeURIComponent(text)}&entity=${entityParam.join(",")}`;
  if (scope) {
    path = `${path}&partner_scope=${scope}`;
  }
  return path;
};
